import React from "react";
import "./ThankyouScreen.scss"
import { Thankyou } from "components/thankyou";
import { Header } from "components/header";
import { CardLayout } from "components/cardLayout";
import { amslogo, logo } from 'assets/images';
import { navigate } from "@reach/router";
import {updateLead} from "core/services/updateLeadStatusService"
import {sendTextMessageToCustomer} from "core/services/sendTextMessageToCustomerService"

declare global {
    interface Window { dataLayer: any; }
 }
 window.dataLayer = window.dataLayer || {};
export interface ThankyouScreenProps {
    affirmCard?: any;
}

export interface ThankyouScreenState {
    Customer:any;
    amounts:any;
}

class ThankyouScreen extends React.Component<ThankyouScreenProps, ThankyouScreenState> {
    constructor(props: ThankyouScreenProps) {
        super(props);
        this.state = {
            Customer:JSON.parse(localStorage.getItem("customerDetails")||'{}'),
            amounts: JSON.parse(localStorage.getItem("amounts")||'{}')
        };

    }
    onLeftIconPress(){
        navigate('/');
    }

    async updateLeadStatus(){

        var customerID =  this.state.Customer.customerID
        var moveID = this.state.Customer.moveID
        var moveDailySheetID = this.state.Customer.moveDailySheetID
        var customerPh = this.state.Customer.customerPh.replace("-","").replace("-","")
        var customerName = this.state.Customer.customerName
        var deposit = "$"+this.state.amounts.find((item:any)=> item.type==="Deposit").amount;
       // var phno = this.state.Customer.
       console.log("calling update lead service................")
 let response = await updateLead(customerID, moveID, moveDailySheetID);
 if(localStorage.getItem("isAffirm")==="0")
 var response_sms = await sendTextMessageToCustomer(customerID, customerPh, customerName, deposit);

 console.log(response)
         
     }

     componentDidMount(){
        window.dataLayer.push({
            event: 'pageview',
            page: { path: "/newThankyou" }
        })
        console.log("updating lead status................")
  //      if(localStorage.getItem("isAffirm")==="1"){
        this.updateLeadStatus()
//localStorage.removeItem("isAffirm")
       // }

    }
    render() {
        return (
            <div className="thankyou-container">
                <Header
                   // leftIcon={'home'}
                  //  leftText={'Home'}
                  //  rightIcon={"phone"}
                    rightText={"Call Us"}
                    onLeftIconPress={this.onLeftIconPress}
                />
                <div className="thankyou-title">
                    <h1>Thank You!</h1>
                </div>
                <div className="thankyou-subtitle">
                    <h2>Your move is booked! Don’t forget to add your Move Day to your calendar.</h2>
                </div>
                <Thankyou />
                {this.props.affirmCard &&
                    <CardLayout>
                        <div className="thankyou-logo">
                            <img src={logo} alt="logo" />
                            <p>+</p>
                            <img src={amslogo} alt="amslogo" />
                        </div>
                        <div className="confirm-email">
                            <p>You’re financing your move with Affirm. Check your email for payment details.</p>
                        </div>
                    </CardLayout>
                }
            </div>
        );
    }
}

export default ThankyouScreen;